//const API_ROOT = "https://localhost:44357/api";
//const API_ROOT = "http://launchpadlicensingserver-dev.eu-west-1.elasticbeanstalk.com/api";
//const API_ROOT = "http://LaunchpadLicensingServer-env-prod.eba-f4jhkzyf.eu-west-1.elasticbeanstalk.com/api";
const API_ROOT = "https://licensing-dev.quixant.com/api";
export default API_ROOT;